import React, { createContext, useCallback, useMemo, useReducer } from 'react';

export const PageContext = createContext({ data: {}, dispatch: () => {} });

const reducer = (state, { type, data }) => ({
  ...state,
  [type]: data,
});

const PageContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {});

  const customDispatch = useCallback(
    (key, data) => {
      dispatch({ type: key, data });
    },
    [dispatch]
  );

  const contextValue = useMemo(
    () => ({
      data: state,
      dispatch: customDispatch,
    }),
    [customDispatch, state]
  );

  return (
    <PageContext.Provider value={contextValue}>{children}</PageContext.Provider>
  );
};

export default PageContextProvider;
